import {
  ALL_SHARD_MODULES,
  getTranslatedText,
  OPERATOR_COMPONENT_MAP
} from '@nile/components';
import { AccountClient, GET_FIELD } from '@nile/graphql';
import { cloneDeep, includes, pick } from 'lodash';

function getPropValues(item, module) {
  let Module = module;
  if (item) {
    let columnName = item;
    if (item.split('.')?.length > 1) {
      Module = item.split('.').shift();
      columnName = item.split('.').pop();
    }
    return AccountClient.query({
      query: GET_FIELD,
      variables: {
        input: {
          columnName,
          entity: ALL_SHARD_MODULES?.[Module] || Module
        }
      }
    });
  }
  return null;
}

const getInputType = (selectedField, operator) => {
  if (!operator) return null;
  if (includes(['numeric', 'decimal'], selectedField?.filterType)) {
    return 'number';
  }
  return OPERATOR_COMPONENT_MAP[operator];
};

const getValueEditorType = (selectedField, operator) => {
  if (!operator) return null;
  if (
    includes(
      ['text', 'read_only', 'numeric', 'decimal'],
      selectedField?.filterType
    )
  ) {
    if (selectedField.dataType === 'datetime') {
      switch (operator) {
        case 'after':
        case 'before':
          return 'datetime_picker';
        case 'between':
          return 'dual_datatime_picker';
        default:
          break;
      }
    }
    if (selectedField.dataType === 'boolean') {
      switch (operator) {
        case 'is':
          return 'boolean_select';
        default:
          break;
      }
    }
    if (selectedField.dataType === 'number_unit') {
      switch (operator) {
        case 'isEmpty':
        case 'isNotEmpty':
          return null;
        default:
          return 'unit';
      }
    }
    if (selectedField?.autoComplete) {
      switch (operator) {
        case 'is':
        case 'isNot':
          return 'search_select';
        case 'includes':
        case 'notIncludes':
          return 'multi_search_select';
        case 'isEmpty':
        case 'isNotEmpty':
          return null;
        case 'startsWith':
        case 'endsWith':
        case 'contains':
        case 'notContains':
          return 'text';
        default:
          return selectedField?.filterType || 'text';
      }
    }
    switch (operator) {
      case 'isEmpty':
      case 'isNotEmpty':
        return null;
      case 'on':
      case 'inNext':
      case 'inLast':
      case 'notInLast':
      case 'after':
      case 'before':
      case 'between':
        return OPERATOR_COMPONENT_MAP[operator];
      case 'includes':
      case 'notIncludes':
        return 'multi_select_text';
      default:
        return 'text';
    }
  }
  if (selectedField?.dataType === 'datetime') {
    switch (operator) {
      case 'after':
      case 'before':
        return 'datetime_picker';
      case 'between':
        return 'dual_datatime_picker';
      default:
        break;
    }
  }
  if (selectedField?.dataType === 'boolean') {
    switch (operator) {
      case 'is':
        return 'boolean_select';
      default:
        break;
    }
  }
  if (selectedField?.autoComplete) {
    switch (operator) {
      case 'is':
      case 'isNot':
        return 'search_select';
      case 'includes':
      case 'notIncludes':
        return 'multi_search_select';
      case 'isEmpty':
      case 'isNotEmpty':
        return null;
      case 'startsWith':
      case 'endsWith':
      case 'contains':
      case 'notContains':
        return 'text';
      default:
        return selectedField?.filterType || 'text';
    }
  }
  return OPERATOR_COMPONENT_MAP[operator];
};

function checkInactiveField({ allEntities, allOperators, intl }) {
  const allFields = [];

  allEntities.getEntitiesMeta.forEach((entity) => {
    entity.attributes.forEach((attribute) => {
      allFields.push({
        ...attribute,
        entityName: entity?.name
      });
    });
  });

  return (args) => {
    const { field } = args;

    const processedOperators = cloneDeep(
      allOperators.getRuleBuilderOperators.operators
    );
    Object.keys(processedOperators).forEach((key) => {
      processedOperators[key] = getTranslatedText(
        intl,
        processedOperators[key]
      );
    });
    const operatorMap = allOperators.getRuleBuilderOperators.operatorType;

    let inactiveField = null;
    if (field.includes('.')) {
      const fieldAttributes = field.split('.');
      // const entity = fieldAttributes[fieldAttributes?.length - 2];
      const fieldName = fieldAttributes[fieldAttributes?.length - 1];
      // const entityFields = getEntityAttributes(allEntities, entity);
      inactiveField = allFields.find((f) => f.name === fieldName);
    } else {
      inactiveField = allFields.find((f) => f.name === field);
    }

    if (inactiveField) {
      const requiredOperators = pick(
        processedOperators,
        operatorMap[inactiveField?.dataType]
      );
      let formattedOperatorValues = [];
      if (
        operatorMap?.[inactiveField?.dataType]?.findIndex(
          (el) => el === 'placeholders'
        ) > -1
      ) {
        const metaPlaceholders = inactiveField?.placeholders || [];
        formattedOperatorValues = metaPlaceholders.map((el) => {
          return {
            name: el,
            label: getTranslatedText(intl, el),
            type: 'placeholder'
          };
        });
      } else {
        Object.keys(requiredOperators).forEach((prop) => {
          const obj = {
            name: prop,
            label: requiredOperators[prop]
          };
          formattedOperatorValues.push(obj);
        });
      }
      return {
        fieldData: inactiveField,
        operators: formattedOperatorValues,
        getValues: async function(selectedField, operator) {
          const result = await getPropValues(
            selectedField,
            inactiveField?.entityName || module
          );

          const fldOptions =
            result?.data?.getField?.options ||
            result?.data?.getField?.fieldOptions;
          return result.data
            ? fldOptions?.map((el) => {
                return {
                  name: el?.value,
                  value: el?.value,
                  label: el?.value
                };
              })
            : [];
        },
        getValueEditorType: (_, operator) => {
          return getValueEditorType(inactiveField, operator);
        },
        getInputType: (_, operator) => {
          return getInputType(inactiveField, operator);
        }
      };
    }
    return null;
  };
}

export default checkInactiveField;
